
        import 'QuoteFooter.7493759.css-module'
        export default {"quoteFooter":"quoteFooter_QuoteFooter_7493759"}
    